import LayoutPage from "../../Components/LayoutPage";
import Buttons from "./Components/Buttons";
import ChallengeInfoContainer from "./Components/ChallengeInfoContainer";
import PhaseInfoContainer from "./Components/PhaseInfoContainer";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/api";

export default function ChallengeInfo() {
  const [challenge, setChallenge] = useState(null);
  const { challengeId } = useParams();
  const fetchChallengeData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/challenges/admin/${challengeId}/phases/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/challenges/admin/${challengeId}/phases/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Categories Data:", data);
      setChallenge(data);
    } catch (error) {
      console.error("Error fetching categories data:", error);
    }
  };
  useEffect(() => {
    fetchChallengeData();
  }, []);
  return (
    <LayoutPage
      activeIndex={4}
      navItems={["مدیریت چالش‌ها", `چالش ${challengeId}`]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto"
    >
      <Buttons data={challenge?.challenge || null} />
      <ChallengeInfoContainer data={challenge?.challenge || null} />
      <div className="w-full">
        <div className="w-full overflow-x-auto inline-flex gap-5 whitespace-nowrap align-top">
          {challenge?.phases &&
            challenge.phases.map((phase, index) => (
              <PhaseInfoContainer
                key={index}
                header={`اطلاعات فاز ${
                  phase.phase_type === "phase1"
                    ? "۱"
                    : phase.phase_type === "phase2"
                      ? "۲"
                      : "قابل برداشت"
                }`}
                headSVG="info"
                phaseData={phase}
              />
            ))}
        </div>
      </div>
    </LayoutPage>
  );
}
